<template>
  <v-container>
    <div class="elevation-2 px-5 mt-3">
      <SimplePageHeader title="Users" class="px-4 pr-5 mb-5">
        <template v-slot:right-buttons>
          <ButtonCustomIcon
            icon="add"
            color="primary"
            text="Add"
            :routeName="userCreateRoute.name"
            :block="true"
          />
        </template>
      </SimplePageHeader>
      <UserFilters
        class="px-5 mb-sm-5"
        :firstNames="firstNames"
        :lastNames="lastNames"
        @search="handleSearchClick"
        @clear="handleSearchClick"
      ></UserFilters>
    </div>
    <v-container fluid class="px-0 pt-2 mt-4">
      <v-layout column>
        <v-data-table
          dense
          :headers="headers"
          :items="userList"
          class="elevation-2"
        >
          <template v-slot:item.active="{ item }">
            <v-simple-checkbox
              v-model="item.active"
              disabled
            ></v-simple-checkbox>
          </template>
          <template v-slot:item.securityRoles="{ item }">
            {{ item.securityRoles | roleLabel }}
          </template>
          <template v-slot:item.action="{ item }">
            <v-btn
              class="mx-1 my-1"
              color="primary"
              outlined
              @click.prevent="editUser($event, item)"
            >
              <v-icon color="primary">edit</v-icon>
            </v-btn>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="mx-0 my-1"
                       color="primary"
                       outlined
                       v-bind="attrs"
                       v-on="on"
                       @click="editUserPassword(item)"
                >
                  <v-icon color="primary">vpn_key</v-icon>
                </v-btn>
              </template>
              <span>Change User's Password</span>
            </v-tooltip>
          </template>
        </v-data-table>
        <UserPasswordChangeModal
          :userID="currentUserID"
          ref="userPasswordModal"
        ></UserPasswordChangeModal>
      </v-layout>
    </v-container>
    <BottomSpacer></BottomSpacer>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import { mapFields } from '@/vueHelpers/vuex'
import UserFilters from './UserFilters'
import { userCreateRoute, userEditRoute } from '@/lib/constants/routes'
import { ButtonAdd, BottomSpacer, ButtonCustomIcon } from '@/components/buttons'
import { DynamicModal } from '@/components/dialogs'
import { SimplePageHeader } from '@/components/pageComponents'
import UserPasswordChangeModal from '@/components/users/UserPasswordChangeModal'

export default {
  components: {
    UserPasswordChangeModal,
    UserFilters,
    ButtonAdd,
    BottomSpacer,
    DynamicModal,
    ButtonCustomIcon,
    SimplePageHeader
  },
  data () {
    return {
      userCreateRoute,
      headers: [
        { text: 'First Name', value: 'firstName', width: '13.6%' },
        { text: 'Last Name', value: 'lastName', width: '13.6%' },
        { text: 'Email', value: 'emailAddress', width: '26.6%' },
        { text: 'Security Roles', value: 'securityRoles', align: 'center', width: '16.6%' },
        { text: 'Active', value: 'active', align: 'center', width: '8%', sortable: false },
        { text: 'Actions', value: 'action', align: 'center', class: 'text-xs-right', sortable: false, width: '22.6%' }
      ],
      showModal: false,
      modalTitle: '',
      currentUserID: 0,
      firstNames: [],
      lastNames: []
    }
  },
  computed: {
    ...mapFields('users', [
      'userList'
    ]),
    ...mapFields('userFilters', [
      'firstName',
      'lastName',
      'securityRoles',
      'includeInactive'
    ])
  },
  created () {
    this.getUsers().then((users) => {
      this.firstNames = users.map((user) => { return { firstName: user.firstName.trim() } })
      this.lastNames = users.map((user) => { return { lastName: user.lastName.trim() } })
      this.firstNames.sort((a, b) => (a.firstName > b.firstName) ? 1 : -1)
      this.lastNames.sort((a, b) => (a.lastName > b.lastName) ? 1 : -1)
      this.userList = this.userList.filter(
        (user) =>
          user.firstName.includes(this.firstName ? this.firstName : '') &&
          user.lastName.includes(this.lastName ? this.lastName : '') &&
          (this.securityRoles ? user.securityRoles.includes(this.securityRoles) : true) &&
          (user.active || user.active === !this.includeInactive))
    })
  },
  methods: {
    ...mapActions('users', [
      'getUsersWithFilters',
      'getUsers'
    ]),
    ...mapActions('userFilters', [
      'clearFilters'
    ]),
    editUser (event, user) {
      if (event.ctrlKey === true) {
        let route = this.$router.resolve({ name: userEditRoute.name, params: { id: user.id } })
        window.open(route.href, '_blank')
      } else {
        this.$router.push({ name: userEditRoute.name, params: { id: user.id } })
      }
    },
    editUserPassword (user) {
      this.currentUserID = user.id
      this.$refs.userPasswordModal.showModal()
    },
    handleSearchClick () {
      this.getUsersWithFilters().then(() => {
        this.userList = this.userList.filter(
          (user) => (user.active || user.active === !this.includeInactive))
      })
    },
    closeDialog () {
      this.showModal = false
    }
  }
}
</script>
